import { Button, Drawer, Radio, Tag, Input, Switch, Checkbox, Alert, Tooltip, Card, InputNumber, Select } from "antd";
import { useState, useRef, useEffect } from "react";
import { CustomEdge, CustomHandle } from "../handler/main";
import {
    Position,
    Handle,
    useReactFlow,
    MarkerType
} from '@xyflow/react';
import './main.css'
import DeleteNode from "../delete_node/main";
import { ClockCircleOutlined } from '@ant-design/icons';


export default function FollowersOnly({ id, data }) {
    const { updateNodeData } = useReactFlow();

    const [showTriggerModal, setShowTriggerModal] = useState(false)
    const [messages, setMessages] = useState(data?.messages)

    const [mediaURLS, setMediaURLS] = useState([])


    const [followUpDuration, setFollowUpDuration] = useState(data?.follow_up_duration || 30);
    const [followUpDurationType, setFollowUpDurationType] = useState(data?.follow_up_duration_type || "m");



    useEffect(() => {
        setMessages(data?.messages)
    }, [data])
    const toggleDrawer = () => {
        let toogle = data?.toogleDrawer == undefined ? false : data?.toogleDrawer
        updateNodeData(id, { ...data, toogleDrawer: !toogle, messages: messages })
    };


    useEffect(() => {
        updateNodeData(id, { ...data, follow_up_duration: followUpDuration, follow_up_duration_type: followUpDurationType })
    }, [followUpDuration, followUpDurationType])

    return (
        <div className="flow-comp">
            <CustomHandle type="target" id={`${id}`} />

            <div className="comp-header">
                <DeleteNode updateNodeData={updateNodeData} id={id} data={data} />

                <p className="comp-title" onClick={toggleDrawer}>User Follows or Not</p>
            </div>
            <Button color="default" variant="solid"
                block style={{
                    display: "block",
                    alignSelf: "center", // Aligns the button to the right
                    // paddingRight:"8px",
                    // paddingLeft:"8px",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    borderRadius: "4px",
                    textAlign: "center", margin: 0, marginTop: "10px", marginBottom: "2px"
                }}>

                <CustomHandle type="source" id={`${id}-follow-flow`} />

                user following you

            </Button>

            {data.message_reply == "true" ?
                <div style={{ marginTop: "10px", maxWidth: "100px", backgroundColor: "rgba(237,106,90,.24)", borderRadius: "10px", padding: "10px" }}>
                    <p style={{ lineHeight: "16px" }}>If user didn't follow you! send message or Configure Flow.</p>
                    <Button onClick={toggleDrawer} style={{ margin: "0 auto", marginTop: "4px", marginLeft: "10px" }} color="primary" type="primary" danger>Edit message</Button>
                </div>
                : <Button color="primary" type="primary"
                    block style={{
                        display: "block",
                        alignSelf: "center", // Aligns the button to the right
                        // paddingRight:"8px",
                        // paddingLeft:"8px",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        borderRadius: "4px",
                        textAlign: "center", margin: 0, marginTop: "4px", marginBottom: "2px"
                    }} danger>

                    <CustomHandle type="source" id={`${id}-not-follow-flow`} />

                    user Not following you

                </Button>

            }

            {/* <Tooltip title="If user not followed you and if there's no next step connected then we send follow up message, Click to edit follow up duration. Connect the next steps."> */}
            <Button
                onClick={toggleDrawer}
                className="follow-up-btn"
                color="purple" variant="filled"
                style={{
                    display: 'block',
                    width: 'auto',
                    alignSelf: 'flex-end',
                    paddingRight: '10px',
                    paddingLeft: '10px',
                    borderRadius: '10px',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textAlign: 'right',
                    margin: 0,
                    fontSize: "12px",
                    cursor: "pointer",
                    marginTop: "10px",

                }}
                // onClick={() => {
                //     toggleDrawer(true); setShowSubConfig(true);
                // }}
                icon={<ClockCircleOutlined style={{ fontSize: "10px", marginRight: "4px" }} />}
            >
                {data?.follow_up_duration ? "Follow up after " : "Follow Up "} {data?.follow_up_duration} {data?.follow_up_duration_type == "m" ? "Min" : data?.follow_up_duration_type == "h" ? "Hrs" : data?.follow_up_duration_type == "s" ? "Sec" : ""}
                <CustomHandle
                    id={`${id}-followup`}
                    type={'source'}
                    onDelete={() => console.log('Delete edge action')}
                />
            </Button>
            {/* </Tooltip> */}



            <Drawer
                width={"500px"}
                style={{ backgroundColor: '#f5f5ff' }}
                //open={openDrawer}
                placement="left"
                open={data?.toogleDrawer}
                onClose={toggleDrawer}
                // onClose={() => {setOpenDrawer(false)}}
                title="Followers Only"
            >

                {/* <div className="trigger-action-box">
                    <h4>Step 1: Check if user following you or not.</h4>
                    <p>Whenever audience send's you message or comment on your posts, we'll check this step.</p>
                </div> */}

                <Card className="sub-msg-conf-card">
                    <h4>If user not following you.</h4>
                    <p>If audience not following you, you can either send a message or confingure a flow.</p>
                    <div className="flex-divider">
                        <Radio.Group onChange={(e) => { updateNodeData(id, { ...data, message_reply: e.target.value }) }} value={data.message_reply || "true"}>
                            <Radio.Button value="true">Send a message</Radio.Button>
                            <Radio.Button value="false">Configure a flow</Radio.Button>
                        </Radio.Group>
                    </div>
                    {
                        data.message_reply == "true" ?
                            <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Input
                                    style={{ width: "80%", margin: "0 auto", textAlign: "left" }}
                                    onChange={(e) => {
                                        updateNodeData(id, { ...data, message: { ...data.message, title: e.target.value } })
                                    }} value={data.message.title} placeholder="Follow for exclusive content" />

                                <Input.TextArea
                                    style={{ width: "80%", margin: "0 auto", textAlign: "left" }}
                                    placeholder="Some description (Optional)"
                                    onChange={(e) => {
                                        updateNodeData(id, { ...data, message: { ...data.message, description: e.target.value } })
                                    }} value={data.message.description}
                                    autoSize={{ minRows: 3, maxRows: 5 }}
                                />
                                <Input
                                    style={{ width: "50%", margin: "0 auto", textAlign: "center" }}
                                    onChange={(e) => {
                                        updateNodeData(id, { ...data, message: { ...data.message, button: e.target.value } })
                                    }}

                                    value={data.message.button}
                                    placeholder="Started Following you(Button text)" />
                            </div>
                            : <p>Close this and configure the flow in flow editor.</p>
                    }
                </Card>

                <Card className="sub-msg-conf-card">
                    <h3 > <ClockCircleOutlined style={{ color: "purple" }} /> Follow Up</h3>

                    <p>If user not resoponded to this question, send follow up message.</p>


                    <>
                        <h4>Follow up after</h4>

                        <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "10px" }}>
                            <InputNumber value={followUpDuration} onChange={(value) => { setFollowUpDuration(value) }} />
                            <Select style={{ flex: "1" }} defaultValue={followUpDurationType} onChange={(value) => { setFollowUpDurationType(value); }} options={[{ "label": "Seconds", "value": "s" }, { "label": "Minutes", "value": "m" }, { "label": "Hour", "value": "h" }]} />
                        </div>
                    </>

                    <p style={{ color: "rgba(0,0,0,.4)" }}>Note : Maximum allowed is 24 hours, set 0 for no follow up.</p>


                </Card>
                {/* </div> */}

                {/* <div className="trigger-action-box">
                    <h4>Step 3: If user following you.</h4>
                    <p>If audience started following now or before, you can continue with the flow, please close this and continue with the flow configuration.</p>
                </div> */}





            </Drawer>
        </div>
    )


}